import React from 'react';

import {cn} from "@/lib/utils/cn";


function RawLayout(props) {

    return (<>
        <div className="flex items-center justify-center">
            <div className={''}>
                <div className={cn("flex flex-col gap-6")}>
                    {props.children}
                </div>
            </div>
        </div>

    </>);
}

export default RawLayout;